// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"0d577cc8","442":"67a7d5ef","453":"88fdeea0","572":"99efb125","739":"d248c79a"}[chunkId] + ".js";
};